import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import './home-assistant.css';

/**
 * HomeAssistant — the W00 FAB + slide-up assistant sheet. Visual/entry shell:
 * the suggestion chips route into the live catalog (/search). Conversational AI
 * is a T1 capability, so the free-text input is a preview (also routes to
 * /search) — kept honest, no fake answers.
 */
const SUGGESTIONS = [
  '¿Qué auto me conviene con presupuesto de $25k?',
  '¿Cuál SUV tiene mejor relación precio-confianza?',
  'Mejor auto para tráfico de Santo Domingo',
  '¿Qué considerar antes de comprar usado?',
  '¿Cómo funciona el escrow de CAR-IA?',
];

const SparkIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" />
    <circle cx="9" cy="11" r="1" fill="currentColor" />
    <circle cx="13" cy="11" r="1" fill="currentColor" />
    <circle cx="17" cy="11" r="1" fill="currentColor" />
  </svg>
);

export const HomeAssistant: React.FC = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <>
      <button className="cia-fab" aria-label="Asistente CAR-IA" onClick={() => setOpen(true)}>
        <span className="cia-fab-pulse" />
        <SparkIcon />
      </button>

      {open && (
        <>
          <div className="cia-bot-backdrop" onClick={() => setOpen(false)} />
          <div className="cia-bot-modal" role="dialog" aria-label="Asistente CAR-IA">
            <div className="cia-bot-header">
              <div className="cia-bot-header-row">
                <div className="cia-bot-icon">
                  <SparkIcon />
                </div>
                <div>
                  <div className="cia-bot-question">¿En qué te puedo ayudar hoy?</div>
                  <div className="cia-bot-question-sub">
                    CAR-IA Asistente · Te encuentro el auto perfecto
                  </div>
                </div>
              </div>
              <button className="cia-bot-close" aria-label="Cerrar" onClick={() => setOpen(false)}>
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                >
                  <path d="M6 6l12 12M6 18L18 6" />
                </svg>
              </button>
            </div>
            <div className="cia-bot-body">
              <div className="cia-bot-label">Preguntas populares</div>
              <div className="cia-bot-suggestions">
                {SUGGESTIONS.map((s) => (
                  <button
                    key={s}
                    className="cia-bot-suggestion"
                    onClick={() => {
                      setOpen(false);
                      navigate('/search');
                    }}
                  >
                    {s}
                  </button>
                ))}
              </div>
              <p className="cia-bot-disclosure">
                El asistente conversacional con IA llega en una próxima fase. Por ahora estas
                sugerencias te llevan al catálogo.
              </p>
            </div>
            <div className="cia-bot-inputbar">
              <input
                className="cia-bot-input"
                placeholder="Pregunta cualquier cosa…"
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    setOpen(false);
                    navigate('/search');
                  }
                }}
              />
              <button
                className="cia-bot-send"
                aria-label="Enviar"
                onClick={() => {
                  setOpen(false);
                  navigate('/search');
                }}
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M5 12l7-7 7 7M12 5v14" />
                </svg>
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default HomeAssistant;
